import * as React from 'react';

export interface PanelProps {
  noPadding?: boolean;
  style?: React.CSSProperties;
}

export interface PanelState {
}

export default class Panel extends React.Component<PanelProps, PanelState> {
  constructor(props: PanelProps) {
    super(props);

    this.state = {
    }
  }

  public render() {
    return (
      <div style={this.props.style} className={'panel ' + (this.props.noPadding? '': 'padding')}>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/ui/panel.tsx